const funArray = [

    // ===============================
    // ORIGINAL JOKES (Your existing)
    // ===============================

    {
        funType: "joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"I failed math so many times at school.", punchline:"Now I can't even count how many times I did." }
    },
    {
        funType: "joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"I was wondering why the frisbee kept getting bigger and bigger.", punchline:"But then it hit me!" }
    },
    {
        funType: "joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"I can’t believe I got fired from the calendar factory.", punchline:"I just took a day off." }
    },
    {
        funType: "joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Most people are shocked at me", punchline:"When they find out how bad I am as an electrician" }
    },
    {
        funType: "joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Never trust atoms", punchline:"They make up everything." }
    },
    {
        funType: "joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"I used to think I was indecisive.", punchline:"But now I am not sure" }
    },
    {
        funType: "joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Just burned 2,000 calories.", punchline:"That’s the last time I leave brownies in the oven while I nap." }
    },
    {
        funType: "joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"‘Doctor, there’s a patient on line one that says he’s invisible.’", punchline:"‘Well, tell him I can’t see him right now.’" }
    },
    {
        funType: "joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Today a man knocked on my door and asked for a small donation toward the local swimming pool.", punchline:"So I gave him a glass of water." }
    },
    {
        funType: "joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"I was reading a book about anti-gravity.", punchline:"It’s impossible to put down." }
    },

    // ORIGINAL RIDDLES
    {
        funType:"riddle",
        riddle:{question:"The more you take, the more you leave behind. 'What am I?'", answer:"Footsteps!"},
        joke:{setup:"", punchline:""}
    },
    {
        funType:"riddle",
        riddle:{question:"What 8 letter word can you remove letters from until only one letter is left?", answer:"Starting → staring → string → sting → sing → sin → in → I"},
        joke:{setup:"", punchline:""}
    },
    {
        funType:"riddle",
        riddle:{question:"How did the carnival man win $50 from the boy?", answer:"He wrote 'your exact weight' on paper."},
        joke:{setup:"", punchline:""}
    },
    {
        funType:"riddle",
        riddle:{question:"I am not alive, but I grow; I don’t have lungs, but I need air; I don’t have a mouth, but water kills me. What am I?", answer:"Fire"},
        joke:{setup:"", punchline:""}
    },
    {
        funType:"riddle",
        riddle:{question:"A woman shoots, drowns, and hangs her husband, but he survives. How?", answer:"She’s a photographer developing film."},
        joke:{setup:"", punchline:""}
    },
    {
        funType:"riddle",
        riddle:{question:"I am something people love or hate. I change how you look. I never go down. What am I?", answer:"Age"},
        joke:{setup:"", punchline:""}
    },
    {
        funType:"riddle",
        riddle:{question:"You have me today, tomorrow you’ll have more. I take no space. I am what you saw, not what you see.", answer:"Memories"},
        joke:{setup:"", punchline:""}
    },
    {
        funType:"riddle",
        riddle:{question:"A man breaks traffic laws all day but does nothing wrong. How?", answer:"He was walking, not driving."},
        joke:{setup:"", punchline:""}
    },
    {
        funType:"riddle",
        riddle:{question:"If 11 + 2 = 1, what is 9 + 5?", answer:"2 (clock arithmetic)"},
        joke:{setup:"", punchline:""}
    },

    // ===============================
    // ✅ NEW DAD JOKES (10)
    // ===============================

    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Why don’t eggs tell jokes?", punchline:"They’d crack each other up." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Why don’t skeletons fight?", punchline:"They don’t have the guts." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"I only know 25 letters of the alphabet.", punchline:"I don’t know Y." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"What do you call fake spaghetti?", punchline:"An impasta." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"I’m afraid for the calendar.", punchline:"Its days are numbered." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Why can't your nose be 12 inches long?", punchline:"Because then it would be a foot." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"I used to hate facial hair.", punchline:"But then it grew on me." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Why do dads take extra socks to golf?", punchline:"In case they get a hole in one." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Why did the scarecrow win an award?", punchline:"He was outstanding in his field." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Why did the bicycle fall over?", punchline:"It was two-tired." }
    },

    // ===============================
    // ✅ NEW TECH JOKES (10)
    // ===============================

    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Why was the computer cold?", punchline:"It forgot to close Windows." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Why do programmers hate nature?", punchline:"Too many bugs." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Why do Java developers wear glasses?", punchline:"Because they don't C#." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"I changed my password to 'incorrect'.", punchline:"So when I forget, my computer says: Your password is incorrect." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"How do robots eat guacamole?", punchline:"With computer chips." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Why did the AI quit its job?", punchline:"It felt too used… and not appreciated enough." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Why was the smartphone bad at school?", punchline:"Low battery life, low performance." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"My computer beat me in chess.", punchline:"But I won in kickboxing." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Why was the coder broke?", punchline:"Because he used up all his cache." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Why don’t computers play hide and seek?", punchline:"They always byte when hiding." }
    },

    // ===============================
    // ✅ NEW MATH JOKES (10)
    // ===============================

    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Why was the equal sign humble?", punchline:"It wasn’t less or greater than anyone." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Why do plants hate math?", punchline:"It gives them square roots." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Why was 6 afraid of 7?", punchline:"Because 7 ate 9." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"How do you make 7 even?", punchline:"Remove the S." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Why was the math book sad?", punchline:"It had too many problems." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Why did Pi get a driver's license?", punchline:"It wanted to go full circle." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Parallel lines have so much in common.", punchline:"It’s sad they can never meet." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"What’s a math teacher’s favorite season?", punchline:"Sum-mer." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Dear Algebra, stop asking us to find your X.", punchline:"She’s gone, bro." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Why can’t circles keep secrets?", punchline:"Because they're always full of π." }
    },

    // ===============================
    // ✅ NEW CAR JOKES (10)
    // ===============================

    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Why did the car go to therapy?", punchline:"Too many breakdowns." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"What’s a car’s favorite meal?", punchline:"Brake-fast." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Why did the sedan get promoted?", punchline:"Excellent mileage and great performance." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Why did the turbo engine get arrested?", punchline:"It was too charged." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Why was the car always tired?", punchline:"Because it had too many long drives." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"What car does a sheep drive?", punchline:"A Lamb-orghini." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Why don’t cars ever get lost?", punchline:"They always follow the right lane." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Why did the race car bring a map?", punchline:"In case it took a wrong turn at high speed." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"What’s a mechanic’s favorite type of music?", punchline:"Car-tunes." }
    },
    {
        funType:"joke",
        riddle:{question:"",answer:""},
        joke:{ setup:"Why did the customer bring a ladder to HelloCar?", punchline:"They heard the prices were unbeatable… and wanted to look up to them." }
    }
];

export default funArray;
